import React from 'react'

export default function Blogs() {
    return (
        <div>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, expedita!
        </div>
    )
}
